import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';
import { createContext } from './createContext';

export function runApp() {
  const context = createContext();

  const store = createApplicationState(context);

  renderApplication({ context, store });
}
